import { TimelineOptions } from "./TimelineOptions";
import { Tween } from "./Tween";
import isArray from "lodash/isArray";

/**
 */
export class Timeline extends createjs.Timeline {
  /**
   */
  public group: string | null;

  /**
   *
   * @param target
   * @param props
   */
  constructor(options: TimelineOptions) {
    super(options);
    this.group = options ? options.group : "";
  }

  public addTween(tween: Tween): Tween {
    // If it's another timeline, get all its tweens and them to
    // this timeline.
    if (tween instanceof Timeline) {
      const timeline = tween as Timeline;
      for (let i = 0; i < timeline.tweens.length; i++) {
        const t = timeline.tweens[i];
        super.addTween(t);
      }
    }

    // If it's an array, loop through and add them.
    else if (isArray(tween)) {
      for (let i = 0; i < tween.length; i++) {
        this.addTween(tween[i]);
      }
    }

    //
    else super.addTween(tween);

    return tween;
  }

  /**
   */
  public addTweens(tweens: Tween[]) {
    if (isArray(tweens)) for (let i = 0; i < tweens.length; i++) this.addTween(tweens[i]);
    else this.addTween(tweens);
  }
}
